import { Typography, TextField, Button, Snackbar, Slide } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { Container } from './styles'
import React, { useState, useEffect } from 'react'
import { PhotoCamera } from '@material-ui/icons';
import api from '../../config/api'
import { useParams, useHistory } from 'react-router-dom'
import Loading from '../../components/Loading';

function UpdateProduct() {

    const [name, setName] = useState('')
    const [description, setDescription] = useState('')
    const [value, setValue] = useState('')

    const [imageUrl, setImageUrl] = useState<string>()
    const [image, setImage] = useState<File>()

    const [openSuccess, setOpenSuccess] = useState(false);
    const [openFailed, setOpenFailed] = useState(false);
    const [errorMessage, setErrorMessage] = useState("Erro desconhecido");

    const [loading, setLoading] = useState(false)

    //@ts-ignore
    const { id } = useParams()
    const history = useHistory()

    useEffect(() => {
        setLoading(true)
        async function fetch() {

            const productResponse = await api.get(`/products/${id}`)
            const { name, description, value, image } = productResponse.data.product

            setName(name)
            setDescription(description)
            setValue(value)
            setImageUrl(image)
            setLoading(false)
        }
        fetch()
    }, [])

    const handleCloseSuccess = (event?: React.SyntheticEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenSuccess(false);
        history.push('/products')
    };

    const handleCloseFailed = (event?: React.SyntheticEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenFailed(false);
    };


    function handleName(e: React.ChangeEvent<HTMLInputElement>) {
        setName(e.target.value)
    }

    function handleDescription(e: React.ChangeEvent<HTMLInputElement>) {
        setDescription(e.target.value)
    }

    function handleImage(e: React.ChangeEvent<HTMLInputElement>) {
        if (e.target.files !== null) {
            console.log(e.target.files[0])
            setImage(e.target.files[0])
            setImageUrl(URL.createObjectURL(e.target.files[0]))
        }
    }

    function handleValue(e: React.ChangeEvent<HTMLInputElement>) {
        const value = e.target.value
        //@ts-ignore
        if (!isNaN(value)) {
            setValue(value)
        }
    }

    async function handleSubmit() {
        try {

            const formData = new FormData();
            if (image !== undefined)
                formData.append('file', image)
            formData.append('name', name)
            formData.append('description', description)
            formData.append('value', value)

            const config = {
                headers: {
                    'content-type': 'multipart/form-data'
                }
            }

            const response = await api.put(`/products/${id}`, formData, config)
            if (response.status === 200) {
                setOpenSuccess(true)
            }
        } catch (err) {
            if (err instanceof Error){
                if (err.message === "Missing field") {
                    setOpenFailed(true)
                    setErrorMessage('Digite todos os campos')
                }
            }
            else {
                setOpenFailed(true)
                setErrorMessage('Erro desconhecido!')
            }
        }
    }

    return (

        <Container>
            {
                loading ?
                    <Loading />
                    :
                    <>

                        <div className="form">
                            <Typography variant="h4" style={{ marginBottom: 10, fontWeight: 600 }}>
                                Atualizar o produto {name}
                            </Typography>
                            <TextField
                                className="text-bar"
                                value={name}
                                label="Digite o nome do produto"
                                variant="outlined"
                                onChange={handleName}
                            />
                            <TextField
                                className="text-bar"
                                value={description}
                                label="Digite a descrição do produto"
                                variant="outlined"
                                onChange={handleDescription}
                            />
                            <TextField
                                className="text-bar"
                                value={value}
                                label="Digite o valor do produto"
                                variant="outlined"
                                onChange={handleValue}
                            />
                            <input
                                accept="image/jpeg, image/png"
                                className="upload-input"
                                id="contained-button-file"
                                multiple
                                type="file"
                                onChange={handleImage}
                            />
                            <label htmlFor="contained-button-file" style={{ marginTop: 10 }}>
                                <Button variant="contained" color="primary" component="span">
                                    Carregar foto do produto
                                <PhotoCamera style={{ marginLeft: 5 }} />
                                </Button>
                            </label>
                            <Button variant="contained" color="secondary" className="submit-button" onClick={handleSubmit}>
                                Atualizar
                                 </Button>
                        </div>
                        {
                            imageUrl !== undefined ?
                                <img className="product-container" src={imageUrl} width="500" height="500" />
                                :
                                <div className="no-image-container">
                                    <Typography variant="h5" >
                                        Nenhuma imagem selecionada
                                        </Typography>
                                </div>
                        }
                        <Snackbar open={openSuccess} autoHideDuration={500} onClose={handleCloseSuccess}>
                            <Alert onClose={handleCloseSuccess} severity="success">
                                Produto Atualizado com sucesso!
                             </Alert>
                        </Snackbar>

                        <Snackbar open={openFailed} autoHideDuration={2000} onClose={handleCloseFailed}>
                            <Alert onClose={handleCloseFailed} severity="error">
                                {errorMessage}
                            </Alert>
                        </Snackbar>

                    </>
            }

        </Container>
    );
}

export default UpdateProduct